import { ProfileInfoCopyButton } from "@components/common/profile-info-copy-button";
import { LegacyAdminPanelLink } from "@components/links/legacy-admin-panel-link";
import { BaseProjectProps } from "@custom-types/base-types";
import { ProjectClone } from "@pages/project-profile/project-clone/project-clone";
import { EditProject } from "@pages/project-profile/tab-contents/project-info-tab/edit-project";

/** List of actions performed on a project in project information tab */
export function ProjectInfoActions({
  project,
}: BaseProjectProps): React.JSX.Element {
  return (
    <>
      <LegacyAdminPanelLink subjectType="PROJECT" id={project.id} />
      <ProfileInfoCopyButton subjectType="PROJECT" entity={project} />
      <ProjectClone project={project} />
      <EditProject project={project} />
    </>
  );
}
